import React from 'react';
import { PackagesSection } from '../components/PackagesSection';
export function Packages() {
  return <div data-id="element-1174">
      <PackagesSection data-id="element-1175" />
    </div>;
}